import { CustomStylingConfig, setConfig, } from '@thoughtspot/custom-style-service';
import { translate } from '@thoughtspot/i18n';
import { create } from '@thoughtspot/logger';
import { assign } from '@thoughtspot/string-util';
import { strings } from '@thoughtspot/translations';
import _ from 'lodash';
const logger = create('chart-lib-env-options');
let isInitialized = false;
let flags = {};
const translateFunction = (key, options) => {
    const string = _.get(strings, key);
    if (!options) {
        return string;
    }
    return assign(string, options);
};
export const translation = () => {
    if (_.get(flags, 'usei18', true)) {
        return translate;
    }
    return translateFunction;
};
const defaultOptions = {
    styleConfig: new CustomStylingConfig(1, []),
    flags: {
        usei18: true,
        maxChartLegendCardinality: 250,
        maxLabelCount: 1000,
        getDefaultDataSizeForHighCardinalityCharts: 5000,
        getMaxDataSizeForHighCardinalityCharts: 20000,
        customChartRowsLimit: 20000,
    },
};
export const isChartLibInitialized = () => isInitialized;
export const getEnvFlags = () => {
    return flags;
};
export const getTranslatedTextCallback = () => {
    return translation();
};
export function getEnvOptions(options) {
    const envOption = _.merge(defaultOptions, options);
    flags = envOption.flags;
    if (_.isUndefined(options.getTranslatedText)) {
        envOption.getTranslatedText = translation();
    }
    return envOption;
}
export function initChartLibEnvOptions(options) {
    if (isInitialized) {
        logger.warn('chart-lib is being reinitialized. please verify if this is not expected.');
    }
    setConfig(options.styleConfig);
    flags = options.flags;
    isInitialized = true;
}
//# sourceMappingURL=env.js.map